import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { APP_NAMES, toPackageName } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import type { JsdFetchError } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests';

export const fireSuccessAnalytics = (
	analyticEvent: UIAnalyticsEvent,
	feature: string,
	value: boolean,
) => {
	fireTrackAnalytics(analyticEvent, 'featureSetting updated', {
		feature,
		value,
	});
};

export const fireFailureAnalytics = (
	analyticEvent: UIAnalyticsEvent,
	error: JsdFetchError,
	feature: string,
	value: boolean,
) => {
	fireErrorAnalytics({
		meta: {
			id: 'updateFeaturesSetting',
			packageName: toPackageName(APP_NAMES.ITSM_FEATURES_SETTINGS),
			teamName: 'jsd-shield',
		},
		error,
		event: analyticEvent,
		attributes: {
			feature,
			value,
		},
		sendToPrivacyUnsafeSplunk: true,
	});
};
